import { contractsService, clientDDRsService } from '../services/api';
import { mensagemDoErroDeCarga } from '../design';

/**
 * Os contratos e DDRs ATIVOS de um cliente, lidos NO SERVIDOR na hora de inativá-lo (08/10/2026).
 *
 * Inativar um cliente cancela os contratos ativos e inativa os DDRs ativos dele. A decisão (perguntar ou não) e a
 * cascata usavam as listas da MEMÓRIA do App. A dos DDRs vem de uma carga que falha calada (clientDDRs=[]): com ela
 * falhando, o cliente só com DDRs era inativado SEM pergunta, e os DDRs ficavam Ativos num cliente inativo; e a
 * memória também pode estar velha (um DDR criado por outra pessoa depois da carga). "Não li" não é "não há".
 */
export type DependenciasDoCliente =
  | { lido: true; contratos: any[]; ddrs: any[] }
  | { lido: false; motivo: string };

export async function lerDependenciasAtivas(clientId: number): Promise<DependenciasDoCliente> {
  let contratos: any;
  let ddrs: any;
  try {
    [contratos, ddrs] = await Promise.all([contractsService.getByClient(clientId), clientDDRsService.getByClient(clientId)]);
  } catch (e) {
    return { lido: false, motivo: mensagemDoErroDeCarga(e) };
  }
  if (!Array.isArray(contratos) || !Array.isArray(ddrs)) return { lido: false, motivo: 'a resposta não veio como lista' };
  return {
    lido: true,
    contratos: contratos.filter((c: any) => c.status === 'Ativo'),
    ddrs: ddrs.filter((d: any) => d.status === 'Ativo'),
  };
}

/** A recusa, com o que NÃO foi feito. */
export const recusaSemDependencias = (cliente: string, motivo: string) =>
  `Não inativei ${cliente}: não consegui ler no servidor os contratos e DDRs ativos dele (${motivo}). `
  + 'Sem essa leitura, contratos ou DDRs ativos ficariam de fora do cancelamento. Nada foi gravado. Tente de novo.';
